var _path, _path2, _path3, _path4, _path5;

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

import * as React from "react";

function SvgTaxReport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22 6.00008V8.42008C22 10.0001 21 11.0001 19.42 11.0001H16V4.01008C16 2.90008 16.91 1.99008 18.02 2.00008C19.11 2.01008 20.11 2.45008 20.83 3.17008C21.55 3.90008 22 4.90008 22 6.00008Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M2 7V21C2 21.83 2.94 22.3 3.6 21.8L5.31 20.52C5.71 20.22 6.27 20.26 6.63 20.62L8.29 22.29C8.68 22.68 9.32 22.68 9.71 22.29L11.39 20.61C11.74 20.26 12.3 20.22 12.69 20.52L14.4 21.8C15.06 22.29 16 21.82 16 21V4C16 2.9 16.9 2 18 2H7H6C3 2 2 3.79 2 6V7Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4299 12.0801C10.8799 12.0801 10.4299 12.5301 10.4299 13.0801C10.4299 13.6301 10.8799 14.0801 11.4299 14.0801C11.9799 14.0801 12.4299 13.6301 12.4299 13.0801C12.4299 12.5301 11.9799 12.0801 11.4299 12.0801Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.57007 10.0298C7.13007 10.0298 7.57007 9.57979 7.57007 9.02979C7.57007 8.47979 7.12007 8.02979 6.57007 8.02979C6.02007 8.02979 5.57007 8.47979 5.57007 9.02979C5.57007 9.57979 6.02007 10.0298 6.57007 10.0298Z",
    fill: "currentColor"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12.26 7.73996C11.97 7.44996 11.49 7.44996 11.2 7.73996L5.73996 13.2C5.44996 13.49 5.44996 13.97 5.73996 14.26C5.88996 14.41 6.07996 14.48 6.26996 14.48C6.45996 14.48 6.64996 14.41 6.79996 14.26L12.26 8.79996C12.55 8.50996 12.55 8.02996 12.26 7.73996Z",
    fill: "currentColor"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTaxReport);
export default __webpack_public_path__ + "static/media/tax-report.d290744732dccf0061025affe849ff9c.svg";
export { ForwardRef as ReactComponent };